/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
const tabbableNode = /input|select|textarea|button|object/;
export const focusSelector =
  "a, input, select, textarea, button, object, [tabindex]";

const hidden = (element) => {
  return (
    (element.offsetWidth <= 0 && element.offsetHeight <= 0) ||
    element.style.display === "none"
  );
};

const visible = (element) => {
  let parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidden(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }

  return true;
};

const getElementTabIndex = (element) => {
  let tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  return parseInt(tabIndex, 10);
};

export const focusable = (element) => {
  const nodeName = element.nodeName.toLowerCase();
  const isTabIndexNotNaN = !isNaN(getElementTabIndex(element));
  const res =
    (tabbableNode.test(nodeName) && !element.disabled) ||
    (element instanceof HTMLAnchorElement
      ? element.href || isTabIndexNotNaN
      : isTabIndexNotNaN);

  return res && visible(element);
};

export const tabbable = (element) => {
  const tabIndex = getElementTabIndex(element);
  const isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
};

/**
 * Tabbable elements are elements the user can tab between. This excludes elements with tabIndex=-1
 * */
export const findTabbableDescendants = (element) => {
  return Array.from(element.querySelectorAll(focusSelector)).filter(tabbable);
};
